import { fromAddress, setDefaults } from 'react-geocode';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { constant } from './constant';

setDefaults({
	key: Enviroment.GOOGLE_MAPS_KEY,
	language: 'en',
	region: 'es',
});

export const GeocodeAddress = async (address = constant.defaultAddress) => {
	try {
		const { results } = await fromAddress(address);
		console.log('results: ', results);
		if (results[0].partial_match === true) {
			throw new Error('Dirección inexistente');
		}
		const { lat, lng } = results[0].geometry.location;
		const formatLat = Number(parseFloat(lat).toFixed(6));
		const formatLng = Number(parseFloat(lng).toFixed(6));
		return {
			lat: formatLat,
			lng: formatLng,
		};
	} catch (error) {
		throw error;
	}
};
